class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.isClicked = false;
    this.setupClickEvents();
  }

  setupClickEvents() {
    const summary = this.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', this.onSummaryClick.bind(this));
    }
    document.addEventListener('click', this.onDocumentClick.bind(this));
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.stopPropagation();
    
    if (this.isClicked) {
      this.isClicked = false;
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    } else {
      // Open this menu first with high z-index
      this.isClicked = true;
      this.openMenu();
      // Close others after new menu is visible
      requestAnimationFrame(() => {
        this.closeOtherMenus();
      });
    }
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.isClicked = false;
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    }
  }

  closeOtherMenus() {
    const allHeaderMenus = document.querySelectorAll('header-menu');
    allHeaderMenus.forEach(menu => {
      if (menu !== this && menu.isClicked) {
        // Only close those in clicked mode
        menu.isClicked = false;
        menu.mainDetailsToggle.removeAttribute('open');
        menu.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      }
    });
  }

  openMenu() {
    // Set active class for high z-index before opening
    const content = this.querySelector('.mega-menu__content');
    if (content) {
      document.querySelectorAll('.mega-menu__content').forEach(c => c.classList.remove('mega-menu__content--active'));
      content.classList.add('mega-menu__content--active');
    }
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  close() {
    this.isClicked = false;
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
